import { MailOutlined } from '@ant-design/icons';
import { Pagination, Space, Switch, Table, Tooltip } from 'antd';
import Column from 'antd/es/table/Column';
import { putApi } from 'apis';
import { useSelector } from 'react-redux';
import {
	DeleteActionSvg,
	EditActionSvg,
	SortBottomIcon,
	SortTopIcon,
	TableNextIcon,
	TablePreviousIcon,
} from 'utils/svgs';
import { checkPermission, toastText } from 'utils/utils';
import SearchAndFilter from '../SearchAndFilter';
import styles from './index.module.scss';
import './index.scss';



const CustomTable = ({
	dataSource, handleTableChange, onShowSizeChange, isLoading, search, totalRecords, performSearchHandler, performFilterHandler, filterValue, reinviteUserAction, openDrawerHandler, setDrawerInfoHandler, setEditSelectedUser, showModal, currentPage, pageSize, isSearchCancel, setSearch, setIsSearchCancel }: any) => {


	const userPermissions = useSelector(
		(state: any) => state?.userProfile
	);
	const isEditPermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'Users',
		permission: ['edit'],
	});

	const isDeletePermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'Users',
		permission: ['delete'],
	});
	const isAddPermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'Users',
		permission: ['add'],
	});

	const statusHandler = async (value: any, data: any) => {
		const finalData: any = {
			updateUserCompanyRoleId: data?.userCompanyRoleId,
			status: value,
		};

		try {
			await putApi('/user/status-update', finalData);
			toastText('Status updated successfully', 'success');
		} catch (error: any) {
			toastText('Something went wrong in status update', 'error');
		}
	};

	const editDataHandler = (userObject: any) => {
		openDrawerHandler();
		setDrawerInfoHandler('Edit User');
		setEditSelectedUser(userObject);
	};

	// Delete user data handler
	const deleteDataHandler = (userObject: any) => {
		setEditSelectedUser(userObject);
		showModal();
	};
	return (
		<>
			<div className={`${styles['body']} user-table`} >
				<SearchAndFilter
					performSearchHandler={performSearchHandler}
					searchValue={search}
					performFilterHandler={performFilterHandler}
					filterValue={filterValue}
					title={'User List'}
					openDrawerHandler={openDrawerHandler}
					isSearchCancel={isSearchCancel}
					setSearch={setSearch}
					setIsSearchCancel={setIsSearchCancel}
				/>

				<Table
					rowKey={(record: any) => record?.userCompanyRoleId}
					dataSource={dataSource}
					// key={userPermissions}
					pagination={false}
					loading={isLoading}
					onChange={handleTableChange}
					scroll={{ y: 'calc(100vh - 300px)' }}
				>
					<Column
						title={<p style={{ padding: '0 10px' }}>User</p>}
						dataIndex="name"
						key="name"
						className="user-column bg-white"
						width={'15%'}
						sorter
						sortDirections={['ascend', 'descend', 'ascend']}
						render={(value: any) => (value ? value : '-')}
						sortIcon={({ sortOrder }) => {
							const isAscend = sortOrder === 'ascend';
							const isDescend = sortOrder === 'descend';

							return (
								<>
									<SortTopIcon fill={isAscend ? '#949494' : undefined} />
									<SortBottomIcon fill={isDescend ? '#949494' : undefined} />
								</>
							);
						}}
					/>

					<Column
						title="Role"
						dataIndex="roleName"
						key="roleName"
						className="bg-white"
						width={'12%'}
						render={(value: any) => (value ? value : '-')}
					/>

					<Column
						title="Email"
						dataIndex="email"
						key="email"
						className="bg-white"
						width={'20%'}
						render={(value: any) => (value ? value : '-')}
					/>

					<Column
						title="Login Access"
						dataIndex="status"
						key="status"
						className="bg-white"
						width={'10%'}
						render={(value: any, data: any) => {
							return (
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between',
									}}
								>
									<Space>
										<Switch
											key={Math.random()}
											defaultChecked={value}
											onChange={(e) => statusHandler(e, data)}
											disabled={
												!isEditPermission ||
												data.userId === userPermissions?.data?.id ||
												!data.isVerified ||
												(data.isAdmin && !userPermissions?.data?.isSuperAdmin) ||
												!data?.roleStatus
											}
										/>
									</Space>
								</div>
							);
						}}
					/>
					{(isEditPermission || isDeletePermission) && (
						<Column
							title="Action"
							dataIndex="action"
							key="action"
							className="bg-white"
							width={'15%'}
							render={(value, data: any) => {
								return (
									<Space size={20}>
										{isEditPermission &&
											data.userId !== userPermissions?.data?.id &&
											(!data.isAdmin || userPermissions?.data?.isSuperAdmin) ?
											(<div
												className="cursor-pointer flex align-center justify-center rounded-action-btn"
												onClick={() =>
													editDataHandler(data)
												}
											>
												<EditActionSvg />
											</div>
											) : (
												<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn">

													<EditActionSvg />
												</div>
											)}

										{isDeletePermission &&
											data.userId !== userPermissions?.data?.id &&
											(!data.isAdmin || userPermissions?.data?.isSuperAdmin) ? (
											<div
												className="cursor-pointer flex align-center justify-center rounded-action-btn "
												onClick={() =>
													deleteDataHandler(data)
												}
											>
												<DeleteActionSvg />
											</div>
										) : (
											<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn ">
												<DeleteActionSvg />
											</div>
										)}

										{data.invitationStatus === 'Pending' && isAddPermission && (
											<Tooltip title="Reinvite">
												<div
													className="cursor-pointer flex align-center justify-center rounded-action-btn "
													onClick={() => {
														reinviteUserAction(data);
													}}
												>
													<MailOutlined />
												</div>
											</Tooltip>
										)}
									</Space>
								);
							}}
						/>
					)}
				</Table>

				<div className={styles['pagination__wrapper']}>
					<Pagination
						current={currentPage}
						pageSize={pageSize}
						showSizeChanger
						onChange={onShowSizeChange}
						total={totalRecords}
						itemRender={(page, type, originalElement) => {
							return (
								<div className={styles['pagination']}>
									{type === 'prev' ? (
										<button
											className={`${styles['pagination']} ${styles['pagination__button']}`}
										>
											<TablePreviousIcon />
											<p
												className={
													styles['pagination__previous']
												}
											>
												Previous
											</p>
										</button>
									) : type === 'next' ? (
										<>
											<button
												className={`${styles['pagination']} ${styles['pagination__button']}`}
											>
												<p
													className={
														styles['pagination__next']
													}
												>
													Next
												</p>
												<TableNextIcon />
											</button>
										</>
									) : (
										originalElement
									)}
								</div>
							);
						}}
					/>
				</div>
			</div>
		</>
	);
};

export default CustomTable;
